<template>
  <div style="position: fixed; top: 0; left: -100000px; width: 1000px">
    <div id="network-paper">
      <div class="page">
        <p class="f14 pb20">{{ new Date().getTime() }}</p>
        <p class="f14 pb20">{{ new Date().toUTCString() }}</p>
        <p class="f14 pb20" v-if="data.userinfo">uid: {{ data.userinfo.id }}</p>
        <p class="f14 pb20" v-if="data.userinfo">{{ data.userinfo.englishName }}</p>
        <p class="f14 pb20">{{ data.userAgent }}</p>
        <table class="table padding bb">
          <tr class="bt">
            <td width="200">IP</td>
            <td width="200">Ping</td>
            <td width="200">Download</td>
            <td width="25%">Upload</td>
          </tr>
          <tr class="bt">
            <td>{{ data.ipValue }}</td>
            <td>{{ data.pingString }}</td>
            <td>{{ data.downloadString }}</td>
            <td>{{ data.uploadString }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import printJS from 'print-js';

export default {
  name: 'OrderPaper',
  props: {
    data: Object,
  },
  methods: {
    print() {
      printJS({
        printable: 'network-paper',
        type: 'html',
        style: `
                * { margin: 0; padding: 0 }
                body { color: #000 }
                .page { page-break-before: auto; page-break-after: always; }
                .table {
                  display: block;
                  width: 100%;
                  border-collapse: collapse;
                }
                .table td{
                  vertical-align: top;
                }
                .table.padding td { padding: 10pt; }
                .table td.nopadding { padding: 0 }
                .table td.vab { vertical-align: bottom; }
                .bt { border-top: 1pt solid #ccc }
                .bb { border-bottom: 1pt solid #ccc }
                .f10 { font-size: 10pt; font-weight: 300 }
                .f12 { font-size: 12pt }
                .f14 { font-size: 14pt }
                .f16 { font-size: 16pt }
                .f18 { font-size: 18pt }
                .bold { font-weight: bold }
                .txtc { text-align: center }
                .txtr { text-align: right }
                .title { padding: 0 10pt 20pt }
                .mt2 { margin-top: 2pt }
                .mt20 { margin-top: 20pt }
                .pl10 { padding-left: 10pt }
                .pt20 { padding-top: 20pt }
                .pb20 { padding-bottom: 20pt }
                .boutique { padding: 0 20pt 30pt 0 }
                .w25r { width: 25% }
                .qrcode {
                  padding: 10pt 0 20px 0;
                  border-bottom: 1pt solid #ccc;
                  text-align: right;
                  font-size: 0;
                }
              `,
        // maxWidth: 800,
        onPrintDialogClose: () => {
        },
        targetStyle: [],
        targetStyles: [],
        font_size: 'auto',
        // ignoreElements: [],
        font: 'Roboto, Arial',
        // honorMarginPadding: false,
        imageStyle: 'max-width: 100%;max-height: 200pt',
      });
    },
  },
};
</script>
